var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeEducacaoBeneficio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223,
    height: 82.479,
    viewBox: "0 0 223 82.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.055 22.561)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 16.63,
    transform: "translate(16.63) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.535 44.041)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 16.63,
    transform: "translate(16.63) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(203.37 25.333)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 16.63,
    transform: "translate(16.63) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(178.425 40.577)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 16.63,
    transform: "translate(16.63) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 38.845)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.969,
    cy: 7.969,
    r: 7.969,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.969,
    cy: 7.969,
    r: 4.969,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.685 17.364)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.772,
    cy: 2.772,
    r: 2.772,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.772,
    cy: 2.772,
    r: 1.272,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.567 47.16)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.772,
    cy: 2.772,
    r: 2.772,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.772,
    cy: 2.772,
    r: 1.272,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.84,462.267a2.29,2.29,0,0,0-2.291-2.286H405.8a2.289,2.289,0,0,0,0,4.577h35.745A2.3,2.3,0,0,0,443.84,462.267Z",
    transform: "translate(-382.808 -442.154)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.583,461.313a2.289,2.289,0,1,0,0,4.577h26.69a2.289,2.289,0,0,0,0-4.577Z",
    transform: "translate(-379.058 -435.7)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.981,464.072a8.467,8.467,0,1,0,8.47,8.47A8.478,8.478,0,0,0,413.981,464.072Zm3.893,8.47a3.89,3.89,0,1,1-3.893-3.893A3.891,3.891,0,0,1,417.875,472.542Z",
    transform: "translate(-373.117 -422.331)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.73,485.277a15.42,15.42,0,1,0-19.2,7.43l-3.654,7.751-.468-1.9a2.285,2.285,0,0,0-3.151-1.549l-1.923.853,3.273-6.722-4.115-2.005-6.021,12.375a2.292,2.292,0,0,0,2.993,3.092l5.15-2.3,1.35,5.518a2.306,2.306,0,0,0,1.993,1.736c.076.006.158.012.234.012a2.3,2.3,0,0,0,2.069-1.315l6.868-14.573c.286.012.567.041.853.041s.573-.029.859-.041l6.868,14.573a2.3,2.3,0,0,0,2.069,1.315c.076,0,.158-.006.234-.012a2.305,2.305,0,0,0,1.993-1.736l1.35-5.518,5.156,2.3a2.288,2.288,0,0,0,2.993-3.08Zm-2.893-6.974a10.846,10.846,0,1,1-10.849-10.844A10.86,10.86,0,0,1,435.836,478.3Zm-.193,11.124,4.051,8.458-1.976-.877a2.285,2.285,0,0,0-3.151,1.549l-.468,1.9-3.647-7.751A15.48,15.48,0,0,0,435.643,489.428Z",
    transform: "translate(-384.122 -428.093)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.974,456.932v61.247h22.9V513.6H404.552V461.509h72.581V513.6H459.2v4.577H481.71V456.932Z",
    transform: "translate(-399.974 -456.932)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.656,458.091H401.181v12.477h4.577v-7.9h7.9Z",
    transform: "translate(-394.126 -451.315)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.093,470.568V458.091H410.615v4.577h7.9v7.9Z",
    transform: "translate(-348.412 -451.315)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.615,476.593h12.477V464.116h-4.577v7.9h-7.9Z",
    transform: "translate(-348.412 -422.12)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.181,464.116v12.477h12.475v-4.577h-7.9v-7.9Z",
    transform: "translate(-394.126 -422.12)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeEducacaoBeneficio);
export default __webpack_public_path__ + "static/media/icone-educacao-beneficio.1aeeff2b50ee9fd25bdab468f152162a.svg";
export { ForwardRef as ReactComponent };